
export const currencies = [
  {
    value: 0,
    label: "USD",
    sign: "$",
  },
  {
    value: 1,
    label: "EUR",
    sign: "€",
  },
  {
    value: 2,
    label: "KZT",
    sign: "₸",
  },
];

export const importCountry = [
  {
    value: "KZ",
    label: "calc.kz",
  },
  {
    value: "KG",
    label: "calc.kg",
  },
  {
    value: "BY",
    label: "calc.by",
  },
  {
    value: "AM",
    label: "calc.am",
  },
  {
    value: "RU",
    label: "calc.ru",
  },
];

export const productCategory = [
  {
    value: 1,
    label: "calc.personal_goods",
  },
  {
    value: 2,
    label: "calc.personal_goods_resident_eeu",
  },
  {
    value: 3,
    label: "calc.ethanol",
  },
  {
    value: 4,
    label: "calc.alcohol_beer",
  },
  {
    value: 5,
    label: "calc.personal_transport",
  },
];

export const vehicleCategory = [
  {
    value: 1,
    label: "calc.quad_snow_moto_offroad",
  },
  {
    value: 2,
    label: "calc.motorcycles_mopeds",
  },
  {
    value: 3,
    label: "calc.motor_transport_under12_passengers",
  },
  {
    value: 4,
    label: "calc.cargo_vehicle_under_5tons",
  },
  {
    value: 5,
    label: "calc.personal_trailers",
  },
  {
    value: 6,
    label: "calc.water_aircraft",
  },
  {
    value: 7,
    label: "calc.passenger_cars",
  },
  {
    value: 8,
    label: "calc.electric_passenger_cars",
  },
  {
    value: 9,
    label: "calc.vehicle_bodies",
  },
];

export const importMethod = [
  {
    value: 1,
    label: "calc.accompanied_luggage",
    visibleForProductId: [2, 3, 4, 5],
  },
  {
    value: 2,
    label: "calc.accompanied_luggage_air_transport",
    visibleForProductId: [1],
  },
  {
    value: 3,
    label: "calc.accompanied_luggage_non_air",
    visibleForProductId: [1],
  },
  {
    value: 4,
    label: "calc.delivery_by_carrier",
    visibleForProductId: [1, 3, 4],
  },
  {
    value: 5,
    label: "calc.international_mail",
    visibleForProductId: [1],
  },
];

export const vehicleEngineType = [
  {
    value: 1,
    label: "calc.gasoline",
  },
  {
    value: 2,
    label: "calc.diesel",
  },
  {
    value: 3,
    label: "calc.hybrid",
  },
  {
    value: 4,
    label: "calc.electric",
  },
];
